// extracted by mini-css-extract-plugin
module.exports = {"BackgroundWrapper":"Banner_BackgroundWrapper__1Zaad","Background":"Banner_Background__3rdok","Logo":"Banner_Logo__30g6q","Socials":"Banner_Socials__pVP7N"};